module.exports = __webpack_public_path__ + "media/src/images/top_covers/April_05-7e3af921ba715330b995bd76e6f25c59.png";